// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__12V3V","content":"styles_content__2fCHU","selectAll":"styles_selectAll__3qqc8"};